import moment from 'moment';
import { mask } from 'remask';
import { cpf as validateCpf } from 'cpf-cnpj-validator';
import * as yup from 'yup';

import { unmaskCpf } from '../../utils/patterns';

const schema = yup.object().shape({
  nomeCompleto: yup.string().required('Nome completo deve ser preenchido'),
  cpf: yup
    .string()
    .required('CPF deve ser preenchido')
    .test('validate', 'CPF Inválido', (value) => {
      return validateCpf.isValid(mask(value, unmaskCpf));
    }),
  emailUsuario: yup
    .string()
    .required('E-mail deve ser preenchido')
    .email('Email Inválido'),
  // TODO verificar teste para data inválida
  dataNascimento: yup
    .string()
    .test('validate', 'Data Inválida', (value) => {
      return !moment(value, 'DD/MM/YYYY')
        .format('DD/MM/YYYY')
        .includes('Invalid');
    })
    .required('Data nascimento deve ser preenchida'),
  senha: yup
    .string()
    .required('Senha deve ser preenchida')
    .test(
      'SenhaTamanho',
      'A senha deve ter no mínimo 6 caracteres',
      (value) => {
        if (!value) {
          return true;
        }
        return value.length >= 6;
      }
    ),
  confirmarSenha: yup
    .string()
    .required('Confirmar Senha deve ser preenchido')
    .oneOf([yup.ref('senha')], 'Senhas deve ser idênticas'),
  telefoneUsuario: yup.string().required('Telefone'),
  sexo: yup.string().required('Sexo deve ser selecionado'),
  estado: yup.string().required('Selecione UF'),
  municipio: yup.object().shape({
    nome: yup.string().required('selected'),
  }),
  termsOfService: yup
    .boolean()
    .required()
    .oneOf(
      [true],
      'Termos de uso e politica de privacidade devem ser aprovado'
    ),
});

export default schema;
